<template>
  <div :class="'iq-card ' + className">
    <slot name="cardImage"/>
    <div
        v-if="hasHeaderTitleSlot || hasHeaderActionSlot"
        class="iq-card-header"
        :class="headerClass"
    >
      <div class="iq-header-title">
        <slot name="headerTitle"/>
      </div>
      <div class="iq-card-header-toolbar iq-header-toolbar">
        <slot name="headerAction"/>
      </div>
    </div>
    <b-card-body
        v-if="hasBodySlot"
        :body-class="'iq-card-body ' + bodyClass"
    >
      <slot name="body"/>
    </b-card-body>
    <slot/>
    <div
        v-if="hasFooterSlot"
        :class="'card-footer' + footerClass"
    >
      <slot name="footer"/>
    </div>
  </div>
</template>

<style lang="scss">
  @media (min-width: 461px) {
    .iq-card-header {
      display: flex;
      justify-content: space-between;
    }
    .iq-header-toolbar {
      display: flex;
      align-items: center;
    }
  }
</style>

<script>
export default {
  name: "iq-card",
  props: {
    className: {type: String, default: ""},
    bodyClass: {type: String, default: ""},
    headerClass: {type: String, default: ""},
    footerClass: {type: String, default: ""},
  },
  mounted() {
  },
  computed: {
    hasHeaderTitleSlot() {
      return !!this.$slots.headerTitle;
    },
    hasHeaderActionSlot() {
      return !!this.$slots.headerAction;
    },
    hasBodySlot() {
      return !!this.$slots.body;
    },
    hasFooterSlot() {
      return !!this.$slots.footer;
    },
  },
};
</script>